export const initialState = {
    status: "",
    timestamp: "",
    data: {
        userOrgAccess: null
    }     
};